<div class="maltia-overlay">
  <div class="maltia-overlay__content">
    <img src="assets/images/icon_white.png" alt="Maltia" class="maltia-overlay__logo" />
    <span class="loader"></span>
    <p class="maltia-overlay__text">Por favor espere...</p>
  </div>
</div>
